import React from 'react';
import { useSelector } from 'react-redux';

import { selectQuoteStep } from 'us_pcb_assembly/store/selectors';
import ToasterComponent from 'shared/components/ToasterComponent';
import Parameters from 'us_pcb_assembly/components/Parameters';
import Steps from 'us_pcb_assembly/components/Steps';
import Prices from 'us_pcb_assembly/components/Prices';

const App = () => {
  const quoteStep = useSelector(selectQuoteStep);

  return (
    <div>
      <ToasterComponent />
      <div className="row steps-container">
        <div className="col-12 steps-container-inner">
          <Steps quoteStep={quoteStep} />
        </div>
      </div>
      <div className="row quote-work-area tab-assembly mb-4">
        <div className="col-lg-5 col-xl-4 quoteform-background">
          <div className="parameters">
            <Parameters />
          </div>
        </div>
        <div className="col-lg-7 col-xl-8 px-0">
          <div className="pcb-price-section">
            <Prices />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
